import axiosInstance from './axiosInstance';

export const getPlatformSettings = () =>
	axiosInstance.get('/system/settings');

export const updatePlatformSettings = (settings) =>
	axiosInstance.put('/system/settings', settings);

export const sendTestPlatformNotification = () =>
	axiosInstance.post('/system/settings/test-notification');

export const getNotificationLog = (params = {}) =>
	axiosInstance.get('/system/notification-log', { params });

export const getPublicFeatureFlags = () =>
	axiosInstance.get('/system/public/feature-flags');
